import React, { useEffect, useState } from 'react';
import EmptyLikedWorkshop from './EmptyLikedWorkshops';
import LikedWorkshopCard from './LikedWorkshopCard';

const LikedWorkshopsList = ({
  likedWorkshopsList: initialList = [],
  onLikeDeleteSuccess,
}) => {
  const [list, setList] = useState(initialList);

  useEffect(() => {
    setList(initialList);
  }, [initialList]);

  const handleUnlike = (workshopId) => {
    setList((prev) => prev.filter((item) => item.workshopId !== workshopId));
    if (onLikeDeleteSuccess) {
      onLikeDeleteSuccess();
    }
  };

  return (
    <div className='w-full flex flex-col overflow-hidden'>
      <div className='flex flex-col gap-6 pb-10'>
        {list.length === 0 ? (
          <EmptyLikedWorkshop />
        ) : (
          <div className='flex flex-col gap-3'>
            {list.map((item) => (
              <LikedWorkshopCard
                key={item.workshopId}
                item={item}
                onUnlike={handleUnlike}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LikedWorkshopsList;
